<!--
  과정 큐래이션 목록(Swiper) 컴포넌트
-->
<template>
  <section class="section_home curation" data-effect-slide="scroll">
    <div class="inner">
      <div v-if="curationData !== null" :id="idPrefix + cuId" :class="['mmp_curation', cuType]">
        <div :class="{'has_icon': showTitleIcon && (curationData.icon !== '' || curationData.icon !== null)}" class="curation_header">
          <!-- title -->
          <h2>
            <span v-if="showTitleIcon && (curationData.icon !== '' || curationData.icon !== null)" class="icon">
              <img :src="curationData.icon">
            </span>
            <span class="txt" v-html="curationTitle" />
          </h2>
          <!-- // title -->

          <!-- 더보기 -->
          <button v-if="showMoreBtn" type="button" class="btn_more" @click="getMoreList()">{{ moreBtnTxt }}</button>
          <!-- // 더보기 -->
        </div>

        <div class="curation_content">
          <!-- 큐레이션 리스트 -->
          <div class="wrap_curation swiper-container">
            <div class="inner swiper-wrapper">
              <div v-for="(courseItem, courseIndex) in curationData.data" :key="courseIndex" class="st_item swiper-slide">
                <a :href="courseItem.link" class="st_link">
                  <!-- thumbnail -->
                  <div class="wrap_st_thumb">
                    <img :src="isDesktop ? courseItem.thumbPc : courseItem.thumbMo" :alt="courseItem.title" class="st_thumb">
                  </div>
                  <!-- // thumbnail -->

                  <div class="wrap_st_cont">
                    <div class="cont_top">
                      <!-- label -->
                      <ul v-if="courseItem.label" class="st_label">
                        <li v-for="(labelItem, labelIndex) in courseItem.label" :key="labelIndex">
                          <span>{{ labelItem }}</span>
                        </li>
                      </ul>
                      <!-- // label -->

                      <!-- title-->
                      <p class="st_title">{{ courseItem.title }}</p>
                      <!-- // title-->
                    </div>

                    <div class="cont_bottom">
                      <!-- schedule -->
                      <ul v-if="courseItem.schedule" class="st_schedule">
                        <li v-for="(scheduleItem, scheduleIndex) in courseItem.schedule" :key="scheduleIndex">
                          <span>{{ scheduleItem }}</span>
                        </li>
                      </ul>
                      <!-- // schedule -->

                      <!-- tag -->
                      <ul v-if="showTag && courseItem.tag" class="st_tag">
                        <li v-for="(tagItem, tagIndex) in courseItem.tag" :key="tagIndex">
                          <span>{{ tagItem }}</span>
                        </li>
                      </ul>
                      <!-- // tag -->

                      <!-- rating, review -->
                      <ul v-if="showReview" class="wrap_review">
                        <!-- rating -->
                        <li v-if="courseItem.rating" class="st_rating">
                          <span>{{ courseItem.rating }}</span>
                        </li>
                        <!-- // rating -->

                        <!-- review -->
                        <li v-if="courseItem.review" class="st_review">
                          <span>{{ courseItem.review }}</span>
                        </li>
                        <!-- // review -->
                      </ul>
                      <!-- // rating, review -->
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <!-- // 큐레이션 리스트 -->

          <!-- 스와이퍼용 내비게이션 -->
          <div v-if="cuType !== 'list'" class="swiper_nav">
            <div v-show="curationData !== null && isDesktop" class="swiper-button-prev" />
            <div v-show="curationData !== null && isDesktop" class="swiper-button-next" />
          </div>
          <!-- // 스와이퍼용 내비게이션 -->
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import MotionEffects from '/src/assets/js/MotionEffects'

export default {
  name: 'CompCourseCurationSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  mixins: [MotionEffects],
  props: {
    // 큐레이션 고유번호
    cuId: {
      type: String,
      default: null
    },
    /*
      큐레이션 제목
      - 해당 값을 전달받으면 데이터 객체의 title 값을 덮어씀
    */
    cuTitle: {
      type: String,
      default: ''
    },
    /*
      큐레이션 레이아웃 스타일 (visual, gallery)
      - 이 값을 기준으로 스와이퍼 여부 및 스와이퍼 형태 적용
    */
    cuType: {
      type: String,
      default: 'gallery'
    },
    // 스와이퍼 화면에 노출할 슬라이드 갯수 (PC)
    slidesPerViewPc: {
      type: Number,
      default: 1
    },
    // 스와이퍼 화면에 노출할 슬라이드 갯수 (MO)
    slidesPerViewMo: {
      type: Number,
      default: 1
    },
    // 슬라이드 간격 (PC)
    spaceBetweenPc: {
      type: Number,
      default: 1
    },
    // 슬라이드 간격 (MO)
    spaceBetweenMo: {
      type: Number,
      default: 1
    },
    // 큐레이션 타이틀 영역에 아이콘 표시 여부
    showTitleIcon: {
      type: Boolean,
      default: false
    },
    // 태그 UI 노출 여부
    showTag: {
      type: Boolean,
      default: true
    },
    // 별점, 댓글 UI 노출 여부
    showReview: {
      type: Boolean,
      default: true
    },
    // 더보기 버튼 제공 여부
    showMoreBtn: {
      type: Boolean,
      default: true
    },
    // 더보기 버튼 텍스트
    moreBtnTxt: {
      type: String,
      default: '더보기'
    }
  },
  data () {
    return {
      idPrefix: 'curation_', // wrapper ID 앞에 추가되는 고정 값 (id="curation_'큐레이션고유번호''")
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      isDesktop: true, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      isMobile: false, // 현재 디바이스 viewport width 가 모바일 사이즈인 경우 true
      swiperInstance: null, // 스와이퍼 인스턴스 객체 저장용
      curationTitle: null, // 큐레이션 제목
      curationData: null, // 큐레이션 데이터

      // 스와이퍼 옵션
      swiperOption: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        responsive: true,
        preloadImages: true,
        navigation: {
          prevEl: `#curation_${this.cuId} .swiper-button-prev`,
          nextEl: `#curation_${this.cuId} .swiper-button-next`
        },
        breakpoints: {
          1200: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0
          }
        }
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate () {

  },
  created () {

  },
  beforeMount () {

  },
  mounted () {
    this.setSwiperOption() // 스와이퍼 옵션 설정
    this.getCurationData() // 큐레이션 데이터 설정
  },
  beforeDestroy () {
    if (this.cuType !== 'list') {
      this.destroySwiper()
    }
  },
  methods: {
    // 큐레이션 데이터 설정
    getCurationData () {
      this.$nextTick(() => {
        let result
        // NOTE: 데이터 처리

        result = {
          title: 'AI Tutor가<br>함께하는 과정', // 과정 큐레이션 제목
          icon: '/static/images/@temp/icon_ai_tutor.svg', // 과정 큐레이션 아이콘
          link: 'javascript:void(0)', // 더보기 링크
          data: [
            {
              title: 'ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
              thumbPc: '/static/images/@temp/study_thumb_01.jpg',
              thumbMo: '/static/images/@temp/study_thumb_01.jpg',
              link: 'javascript:void(0)',
              label: [
                '비대면',
                '초급',
                '교재제공'
              ],
              tag: [
                '생성형AI',
                'ChatGPT',
                '프롬프트'
              ],
              schedule: [
                '3/18~3/19',
                '7/8~7/9'
              ],
              rating: '4.5',
              review: '12'
            },
            {
              title: '파이썬과 오픈소스를 활용한 딥러닝(심화)',
              thumbPc: '/static/images/@temp/study_thumb_02.jpg',
              thumbMo: '/static/images/@temp/study_thumb_02.jpg',
              link: 'javascript:void(0)',
              label: [
                '대면',
                '고급',
                '교재제공'
              ],
              tag: [
                '딥러닝',
                'deep learning'
              ],
              schedule: [
                '5/20~5/24',
                '6/17~6/21'
              ],
              rating: '4.6',
              review: '25'
            },
            {
              title: '실무에 바로 적용하는 C Fundamentals',
              thumbPc: '/static/images/@temp/study_thumb_06.jpg',
              thumbMo: '/static/images/@temp/study_thumb_06.jpg',
              link: 'javascript:void(0)',
              label: [
                '대면',
                '초급',
                '교재제공'
              ],
              tag: [
                'C',
                'C 언어',
                'C 기초',
                'C Programming'
              ],
              schedule: [
                '5/27~5/31',
                '8/19~8/23'
              ],
              rating: '4.8',
              review: '67'
            },
            {
              title: '[LIVE] IT 인프라 아키텍처와 클라우드',
              thumbPc: '/static/images/@temp/study_thumb_04.jpg',
              thumbMo: '/static/images/@temp/study_thumb_04.jpg',
              link: 'javascript:void(0)',
              label: [
                '비대면',
                '중급',
                '교재제공'
              ],
              tag: [
                '생성형AI',
                'ChatGPT',
                '프롬프트'
              ],
              schedule: [
                '6/26~6/28',
                '9/25~9/27'
              ],
              rating: '4.5',
              review: '12'
            },
            {
              title: 'SW 품질 향상을 위한 SW 테스팅',
              thumbPc: '/static/images/@temp/study_thumb_05.jpg',
              thumbMo: '/static/images/@temp/study_thumb_05.jpg',
              link: 'javascript:void(0)',
              label: [
                '대면',
                '중급',
                '교재제공'
              ],
              tag: [
                'SW 테스팅',
                'SW 품질관리',
                'QA'
              ],
              schedule: [
                '5/27~5/28'
              ],
              rating: '4.7',
              review: '18'
            }
          ]
        }
        this.curationData = result

        // 큐레이션 제목 설정
        if (this.cuTitle !== '') {
          this.curationTitle = this.cuTitle
        } else {
          this.curationTitle = this.curationData.title
        }

        // 갤러리 타입인 경우 swiper 설정
        if (this.cuType !== 'list') {
          setTimeout( () => {
            this.initSwiper()
          })
        }
      })
    },
    // 스와이퍼 옵션 설정
    setSwiperOption () {
      let slidesPerViewPc = this.slidesPerViewPc
      let slidesPerViewMo = this.slidesPerViewMo

      if (slidesPerViewPc === 1) slidesPerViewPc = 'auto'
      if (slidesPerViewMo === 1) slidesPerViewMo = 'auto'

      this.swiperOption.slidesPerView = slidesPerViewPc
      this.swiperOption.slidesPerGroup = this.slidesPerViewPc
      this.swiperOption.spaceBetween = this.spaceBetweenPc

      this.swiperOption.breakpoints = {
        1200: {
          slidesPerView: slidesPerViewMo,
          slidesPerGroup: this.slidesPerViewMo,
          spaceBetween: this.spaceBetweenMo
        }
      }
    },
    // 스와이퍼 인스턴스 캐치
    getSwiperInstance () {
      this.$nextTick(() => {
        const swiperId = this.idPrefix + this.cuId
        const swiperContainer = document.querySelector(`#${swiperId} .swiper-container`)
        const swiperInstance = swiperContainer.swiper

        if (swiperInstance) {
          return swiperInstance
        } else {
          return false
        }
      })
    },
    // 스와이퍼 UI 설정
    initSwiper () {
      const swiperId = this.idPrefix + this.cuId
      const swiperContainer = document.querySelector(`#${swiperId} .wrap_curation`)

      this.swiperInstance = new Swiper(swiperContainer, this.swiperOption)
    },
    // 스와이퍼 UI 해제
    destroySwiper () {
      const swiperInstance = this.getSwiperInstance()
      if (swiperInstance) swiperInstance.destroy()
    },
    // 더보기 버튼 클릭 메서드
    getMoreList () {
      const cuId = this.cuId
      const url = this.curationData.link

      // NOTE: 더보기 기능 처리
      console.log('큐레이션 ID : ', cuId)
      console.log('url: ', url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompCourseCurationSwiper.vue